import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: "Sarah Jenkins",
    location: "Jersey City",
    text: "Best cleaning service in Jersey City. Always reliable and the attention to detail is unmatched. My apartment has never looked better!",
    rating: 5
  },
  {
    name: "Michael Chen",
    location: "Hoboken",
    text: "Professional, punctual, and the apartment looked amazing. I've tried several services in the area, but CleanHouse NJ is on another level.",
    rating: 5
  },
  {
    name: "Emily Rodriguez",
    location: "Downtown JC",
    text: "I love their recurring service. It's so easy to schedule and I can always trust them to do a fantastic job while I'm at work.",
    rating: 5
  }
];

const Reviews: React.FC = () => {
  return (
    <section className="py-24 bg-brand-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-end justify-between mb-16 gap-8">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-6">
              What Our <span className="text-brand-blue">Clients Say</span>
            </h2>
            <p className="text-lg text-brand-navy/70">
              Don't just take our word for it. We're proud to be the highest-rated cleaning service in Hudson County.
            </p>
          </div>
          <div className="flex items-center space-x-4 bg-white p-6 rounded-3xl shadow-premium border border-gray-100">
            <div className="text-right">
              <p className="text-2xl font-black text-brand-navy">4.9/5.0</p>
              <p className="text-xs font-bold text-brand-navy/40 uppercase tracking-widest">Average Rating</p>
            </div>
            <div className="flex space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white p-10 rounded-[2.5rem] shadow-premium border border-gray-100 relative group hover:-translate-y-2 transition-transform duration-300"
            >
              <Quote className="absolute top-8 right-8 w-12 h-12 text-brand-blue/5 group-hover:text-brand-blue/10 transition-colors" />
              
              <div className="flex space-x-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                ))}
              </div>
              
              <p className="text-brand-navy/80 leading-relaxed mb-8 italic">
                "{testimonial.text}"
              </p>
              
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-brand-blue/10 rounded-full flex items-center justify-center text-brand-blue font-bold">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-brand-navy">{testimonial.name}</h4>
                  <p className="text-xs text-brand-navy/40 font-bold uppercase tracking-widest">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
